export default {
    computed: {
        type_name () {
            if (this.item.building_ranking) {
                const { ranking_type } =  this.item.building_ranking
                return  {
                    comments: '热评榜',
                    views: '人气榜',
                    follows: '关注榜'
                }[ranking_type]
            }
        }
    }
}